import { defineMessages } from '@atlassian/jira-intl';
import { MSTEAM_APP_TYPE, type AppType } from '../../../../../../common/constants';

export const messages = defineMessages({
	slackWorkspaceConnectionRemoveModalHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.slack-workspace-connection-remove-modal-heading',
		defaultMessage: 'Removing this workspace will affect all incidents',
		description: 'Heading for slack project connection remove modal',
	},
	slackWorkspaceConnectionRemoveModalHeadingNew: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.slack-workspace-connection-remove-modal-heading-new',
		defaultMessage: 'Turn off Slack workspace',
		description: 'Heading for slack project connection remove modal',
	},
	workspaceConnectionRemoveModalCancelButton: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.workspace-connection-remove-modal-cancel-button',
		defaultMessage: 'Cancel',
		description: 'Button name for Cancel project connection remove modal',
	},
	workspaceConnectionRemoveModalRemoveButton: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.workspace-connection-remove-modal-remove-button',
		defaultMessage: 'Remove',
		description: 'Button name for Remove project connection remove modal',
	},
	slackWorkspaceConnectionRemoveModalContent: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.slack-workspace-connection-remove-modal-content',
		defaultMessage:
			'This workspace will be removed from all incidents in this service project. Active Slack channels will remain active and agents will still be able to access them.',
		description: 'Content for the slack project connection remove modal',
	},
	slackWorkspaceConnectionRemoveModalContentNew: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.slack-workspace-connection-remove-modal-content-new',
		defaultMessage:
			'Once you turn off <b>{workspaceName}</b>, your team will no longer be able to add Slack channels from the workspace to incidents in this service project. Existing channels won’t be affected.',
		description: 'Content for the slack project connection remove modal',
	},
	msteamsWorkspaceConnectionRemoveModalHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.msteams-workspace-connection-remove-modal-heading',
		defaultMessage: 'Turn off Microsoft tenant',
		description: 'Heading for project connection remove modal',
	},
	msteamsWorkspaceConnectionRemoveModalContent: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.remove-slack-workspace-modal.msteams-workspace-connection-remove-modal-content',
		defaultMessage:
			'Once you turn off <b>{workspaceName}</b>, your team will no longer be able to create new chats or meetings in the tenant for incidents in this service project. Existing chats and meetings won’t be affected.',
		description: 'Content for the project connection remove modal',
	},
});

export const getRemoveModalHeading = (appType: AppType) =>
	appType === MSTEAM_APP_TYPE
		? messages.msteamsWorkspaceConnectionRemoveModalHeading
		: messages.slackWorkspaceConnectionRemoveModalHeadingNew;

export const getRemoveModalContent = (appType: AppType) =>
	appType === MSTEAM_APP_TYPE
		? messages.msteamsWorkspaceConnectionRemoveModalContent
		: messages.slackWorkspaceConnectionRemoveModalContentNew;
